/* Switches Arabic and English live (the whole document flips direction without a reload); signed in, it
 * also saves the profile language. */
import { Translate } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { useSwitchLanguage } from '@/api/hooks/settings'
import { useLocale } from '@/i18n/useLocale'
import { cn } from '@/lib/cn'

export function LanguageSwitch({ className, compact }: { className?: string; compact?: boolean }) {
  const { t } = useTranslation('shell')
  const { locale } = useLocale()
  const other = locale === 'ar' ? 'en' : 'ar'
  const switchTo = useSwitchLanguage()
  return (
    <button
      type="button"
      onClick={() => switchTo(other)}
      lang={other}
      aria-label={t('language.switchTo')}
      className={cn(
        'inline-flex h-9 items-center gap-1.5 rounded-xl px-2.5 text-13 font-semibold text-body transition-colors hover:bg-control hover:text-ink touch:min-h-11',
        className,
      )}
    >
      <Translate className="size-[18px] text-subtle" aria-hidden="true" />
      {compact ? null : <span>{t('language.other')}</span>}
    </button>
  )
}
